// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2dDZE","errors":"Errors_errors__1n8-x"};